// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

type SvgProps = {
    width?: number;
    height?: number;
}

const AnnouncementBannerSVG = (props: SvgProps) => (
    <svg
        width={props.width ? props.width.toString() : '184'}
        height={props.height ? props.height.toString() : '113'}
        viewBox='0 0 184 113'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <rect
            x='2.745'
            y='15'
            width='181'
            height='78'
            rx='5.625'
            fill='var(--center-channel-color)'
            fillOpacity='0.12'
        />
        <path
            d='M11.4834 28L16.9999 33.5618V59L172 59L172 68'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.24'
            strokeLinecap='round'
        />
        <circle
            cx='2.5'
            cy='2.5'
            r='2.5'
            transform='matrix(1 0 0 -1 7 29)'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M59.1304 15H126.87L131 108H55L59.1304 15Z'
            fill='var(--center-channel-color)'
            fillOpacity='0.24'
        />
        <rect
            width='92'
            height='5'
            transform='matrix(1 0 0 -1 47 113)'
            fill='var(--center-channel-color)'
            fillOpacity='0.4'
        />
        <rect
            x='27'
            y='9'
            width='131'
            height='86'
            rx='4'
            fill='var(--center-channel-bg)'
            stroke='var(--center-channel-color)'
            strokeWidth='4'
        />
        <circle
            cx='87.9995'
            cy='41.0007'
            r='5'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M95.9995 41.0007H149.056'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M95.9995 45.0007H149.056'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M95.9995 37.0007H109.175'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='87.9995'
            cy='60.0005'
            r='5'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M95.9995 60.0005H149.056'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M95.9995 64.0005H149.056'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M95.9995 56.0005H109.175'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='87.9995'
            cy='79.0003'
            r='5'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M95.9995 79.0003H149.056'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M95.9995 83.0003H149.056'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M95.9995 75.0003H109.175'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <rect
            x='31'
            y='13'
            width='46'
            height='78'
            fill='#1C58D9'
            fillOpacity='0.16'
        />
        <path
            d='M46.8109 20.0273L63.5002 20.0273'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M46.8109 22.6628L56.4732 22.6628'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='38.5092'
            cy='20.5105'
            r='4.34771'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <circle
            cx='36.4795'
            cy='36.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M42.4189 36.1602H67.0137'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='36.4795'
            cy='43.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M42.4189 43.1602H61.7434'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='36.4795'
            cy='51.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M42.4189 51.1602H69.6489'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='36.4795'
            cy='58.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M42.4189 58.1602H67.0137'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='36.4795'
            cy='65.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M42.4189 65.1602H61.7434'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <circle
            cx='36.4795'
            cy='72.1602'
            r='2'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <path
            d='M42.4189 72.1602H69.6489'
            stroke='var(--center-channel-color)'
            strokeOpacity='0.32'
            strokeLinecap='round'
        />
        <path
            d='M147 101.5H119.5'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M116 101.5H110'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <path
            d='M107 101.5H101'
            stroke='var(--center-channel-color)'
            strokeLinecap='round'
        />
        <path
            d='M29 13C29 11.8954 29.8954 11 31 11H154C155.105 11 156 11.8954 156 13V30H29V13Z'
            fill='#28427B'
        />
        <path
            d='M50 18H74.5948'
            stroke='var(--neutral-0)'
            strokeLinecap='round'
        />
        <path
            d='M50 22H131'
            stroke='var(--neutral-0)'
            strokeLinecap='round'
        />
        <circle
            cx='39.5'
            cy='20.5'
            r='5'
            stroke='var(--neutral-0)'
        />
        <line
            x1='39.5'
            y1='20'
            x2='39.5'
            y2='23'
            stroke='var(--neutral-0)'
        />
        <line
            x1='39.5'
            y1='20'
            x2='39.5'
            y2='23'
            stroke='var(--neutral-0)'
        />
        <line
            x1='39.5'
            y1='18'
            x2='39.5'
            y2='19'
            stroke='white'
        />
        <circle
            cx='172'
            cy='84'
            r='2'
            transform='rotate(-90 172 84)'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <circle
            cx='172'
            cy='78'
            r='2'
            transform='rotate(-90 172 78)'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
        <circle
            cx='172'
            cy='72'
            r='2'
            transform='rotate(-90 172 72)'
            fill='var(--center-channel-color)'
            fillOpacity='0.32'
        />
    </svg>
);

export default AnnouncementBannerSVG;
